import { Controller } from "@hotwired/stimulus"

// THE DUE LIST'S BULK "CREATE WORKS PROJECT" BUTTON (TASK-280.5, decision-94).
// Sits beside `form-picker` on the same row checkboxes (and beside
// due-bulk-schedule, which is the visit button's own, same-site rule). Unlike a
// visit, a works project spans many buildings, so there is no same-site check:
// any ticked mix of asset and site rows will do. form-picker owns the
// enabled/disabled state; this only writes the modal's src, carrying each
// ticked row's key ("asset:<id>:<rule>" / "site:<id>:<rule>") for the server
// to re-resolve — it trusts nothing the browser sends.
export default class extends Controller {
  static targets = ["checkbox", "button"]
  static values = { newPath: String }

  recompute() {
    if (!this.hasButtonTarget) return

    const checked = this.checkboxTargets.filter((checkbox) => checkbox.checked && !checkbox.disabled)
    if (checked.length === 0) return

    const params = new URLSearchParams()
    checked.forEach((checkbox) => params.append("due_rows[]", checkbox.dataset.worksKey))

    this.buttonTarget.setAttribute("data-modal-turbo-frame-src-value", `${this.newPathValue}?${params.toString()}`)
  }
}
